/**
 * Logger service for the Bombardiers Hockey Team website
 * Provides environment-aware logging with different levels
 */

const LOG_LEVELS = {
  ERROR: 0,
  WARN: 1,
  INFO: 2,
  DEBUG: 3,
};

class Logger {
  constructor() {
    this.isDevelopment = process.env.NODE_ENV === 'development';
    this.currentLevel = this.isDevelopment ? LOG_LEVELS.DEBUG : LOG_LEVELS.ERROR;
  }

  /**
   * Log error messages (always shown)
   */
  error(message, ...args) {
    if (this.currentLevel >= LOG_LEVELS.ERROR) {
      console.error('[ERROR]', message, ...args);
    }
  }

  /**
   * Log warning messages (development only)
   */
  warn(message, ...args) {
    if (this.currentLevel >= LOG_LEVELS.WARN) {
      console.warn('[WARN]', message, ...args);
    }
  }

  /**
   * Log info messages (development only)
   */
  info(message, ...args) {
    if (this.currentLevel >= LOG_LEVELS.INFO) {
      console.info('[INFO]', message, ...args);
    }
  }

  /**
   * Log debug messages (development only)
   */
  debug(message, ...args) {
    if (this.currentLevel >= LOG_LEVELS.DEBUG) {
      console.log('[DEBUG]', message, ...args);
    }
  }

  /**
   * Log player stats operations (specialized for hockey stats)
   */
  stats(operation, playerName, details) {
    this.info(`STATS: ${operation} for ${playerName}`, details);
  }

  /**
   * Log Sanity CMS operations
   */
  sanity(operation, details) {
    this.debug(`SANITY: ${operation}`, details);
  }
}

// Export singleton instance
const logger = new Logger();
export default logger;
